import "./modules/about";
import "./modules/front-page";
import "./modules/menu";
import "./modules/blog-cart";
import "./modules/blogs";
import "./modules/quick-access";
import "./modules/single-service";
import "./modules/contact";
import "./modules/testimonial";
import "./modules/testimonialExperienceForm";
import "./modules/mobile-category-list";
import "./modules/ticker";
import "./modules/plyr";
import "./modules/toastify";
import "./modules/image-opener";
import "./modules/call-popup";
import "./modules/change-position-header-with-scroll";
import "./modules/preloader";
import "./modules/studentForm";
